var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 0a7 7 0 00-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 00-7-7zm0 9.5A2.5 2.5 0 119.5 7 2.5 2.5 0 017 9.5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDE0IDIwIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTEyLDJBNyw3LDAsMCwwLDUsOWMwLDUuMjUsNywxMyw3LDEzczctNy43NSw3LTEzQTcsNywwLDAsMCwxMiwyWm0wLDkuNUEyLjUsMi41LDAsMSwxLDE0LjUsOSwyLjUsMi41LDAsMCwxLDEyLDExLjVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNSAtMikiLz4KPC9zdmc+";
export { SvgPin as ReactComponent };